import { render } from "./CommonTabs.vue?vue&type=template&id=16d12e58&scoped=true&ts=true"
import script from "./CommonTabs.vue?vue&type=script&lang=ts"
export * from "./CommonTabs.vue?vue&type=script&lang=ts"

import "./CommonTabs.vue?vue&type=style&index=0&id=16d12e58&lang=stylus&scoped=true"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-16d12e58"]])

export default __exports__